import styled from "styled-components/macro";
import Header from "../../components/header";
import TopBar from "../../components/top_bar";
import SortBar from "../../components/sort_bar";
import CommunityHeader from "../../components/community_header";
import Container from "../../components/container";
import Footer from "../../components/footer";
import Wrapper from "../../components/wrapper";
import HeaderData from "../../components/header_data";
import {useBaseCommunity} from "../../store/hooks";
import {isPseudoCommunity} from "../../store/communites";
import CommunityInfo from "../../components/community_info";
import LegacySortBar from "../../components/legacy/legacy_sort_bar";
import useWindowDimensions from "../../utils/dimensions";
import {themecolors} from "../../utils/themecolors";
import {useModmailIndex} from "../../api/modmail";
import {useFeedback} from "../../store/feedback";
import {useParams} from "react-router-dom";
import TextContent from "../../components/text_content";
import {useRelativeTime} from "../../store";
import NavLink from "../../components/nav_link";

const Main = styled.div``;
const Sidebar = styled.div``;
const SidebarModule = styled.div``;
const Empty = styled.div``;
const SidebarItem = styled.div``;
const MessageTitle = styled.div``;
const MessageMetadata = styled.div``;

const Message = styled(({className, message}) => {

    return (
        <div className={className}>
            <MessageTitle>
                <NavLink href={`modmail/123`} react_route>{message.subject}</NavLink>
            </MessageTitle>
            <MessageMetadata>
                <NavLink href={`/u/${message.author}`} react_route>{message.author}</NavLink> • {useRelativeTime(message?.created, true)} ago
            </MessageMetadata>
            <TextContent content={message.content} />
        </div>

    );
})`
  padding-top: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_2 : '#e5e3e3'};
  ${MessageTitle} {
    font-weight: 500;
  }
  ${MessageMetadata} {
    font-size: 15px;
    padding-bottom: 12px;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_medium_impact_text};
  }
  ${TextContent} {
    font-size: 15px;
  }
  @media only screen and (max-width: 780px) {
    & {
      padding: 16px;
    }
  }
`;

const Modmail = styled(({className}) => {

    const {community} = useParams();
    const baseCommunity = useBaseCommunity();
    const {width} = useWindowDimensions();

    const {feedbackCh, error} = useFeedback();
    const modmail = useModmailIndex(feedbackCh, community, "new");

    const messages = modmail?.messages;

    return (
        <div className={className}>
            <HeaderData title={'Scored'} community={community}/>
            <Header>
                {(baseCommunity !== "TheDonald" || width <= 780) && <TopBar dark legacyConversion={baseCommunity === "TheDonald"}/>}
                {!isPseudoCommunity(community) &&
                <>
                    <CommunityHeader community={community}/>
                    {baseCommunity !== "TheDonald" &&
                    <CommunityInfo desktop community={community}/>
                    }
                </>
                }
                {baseCommunity === "TheDonald" && width > 780 && <LegacySortBar />}
            </Header>
            <SortBar community={community} />
            <Container forceWidth={"slim"}>
                {width > 780 &&
                    <Sidebar>
                        <SidebarModule>
                            <h2>Inbox</h2>
                            <SidebarItem>
                                All
                            </SidebarItem>
                            <SidebarItem>
                                Unread
                            </SidebarItem>
                            <SidebarItem>
                                Ban Appeals
                            </SidebarItem>
                            <SidebarItem>
                                Archived
                            </SidebarItem>
                        </SidebarModule>
                    </Sidebar>
                }
                <Wrapper>

                    {!messages &&
                    <Empty>No mail found.</Empty>
                    }

                    {messages &&
                        <Main>

                            {messages?.map((message) => (
                                <Message key={message.id} message={message}/>
                            ))}

                        </Main>
                    }

                </Wrapper>
                {/*<Sidebar sidebar={style && style.sidebar} community={community} />*/}
            </Container>
            <Footer/>
        </div>
    );
})`
  ${Sidebar} {
    width: 260px;
    flex-shrink: 0;
    margin-right: 24px;
  }
  ${SidebarModule} {
    background-color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_2 : '#fff'};
    padding: 12px 16px;
    border-radius: 8px;
  }
  ${Empty} {
    font-size: 15px;
    text-align: center;
    padding-top: 12px;
  }
  ${SidebarModule} h2 {
    margin: 0 !important;
    font-size: 18px !important;
  }
  ${SidebarItem} {
    font-size: 16px;
    padding: 6px 2px;
  }
  ${Main} {
    background-color: white;
  }
  @media only screen and (min-width: 781px) {
    ${Message}:first-of-type {
      padding-top: 0;
    }
    ${Main} {
      border-radius: 6px;
      padding: 16px;
    }
  }
`;


export default Modmail;
